module.exports = __webpack_public_path__ + "img/ns-spinner.70e088f9.gif";